import { render } from "./UrlSimple.vue?vue&type=template&id=77f3b2a9&scoped=true"
import script from "./UrlSimple.vue?vue&type=script&lang=js"
export * from "./UrlSimple.vue?vue&type=script&lang=js"

import "./UrlSimple.vue?vue&type=style&index=0&id=77f3b2a9&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f3b2a9"]])

export default __exports__